import type { QuoteDetailsDTO } from "~/features/orders/quoteList/api/fetchOrderDetails/dto";
import type { QuoteDTO } from "~/features/orders/quoteList/api/fetchQuoteHistory/dto";
import { isFromDifferentAccOrSalesOrg } from "~/features/orders/orderList/api/fetchOrderHistory/fetchOrderHistory";
import { resolveUrl } from "~/utils/url/urlResolver";

export function constructQuoteDetailsUrl(soNumber: string | null | undefined, dto: QuoteDTO | QuoteDetailsDTO) {
  let url = "";
  if (soNumber) {
    url = resolveUrl(`/quotes/${soNumber}`);
    if (isFromDifferentAccOrSalesOrg(dto)) {
      const params = new URLSearchParams();
      params.append("account", dto.account!.code);
      params.append("salesOrg", dto.account!.salesOrg);
      url = url + "?" + params.toString();
    }
  }
  return url;
}
